<div class="row mb-2">
  <div class="col-12">
    <h5 class="font-size-smaller2">
      {{ 'trade.confirm.hint.headline' | transloco }}
    </h5>
    <div class="font-size-smaller2 mt-2">
      @if (cache?.asset?.instrumentType !== InstrumentType.Crypto) {
        @if (cache?.asset?.complex) {
          {{ 'trade.confirm.hint.complex' | transloco }}
        }
        @if (!cache?.asset?.complex) {
          {{ 'trade.confirm.hint.not-complex' | transloco }}
        }
      } @else {
        {{ 'trade.confirm.hint.crypto' | transloco }}
      }
    </div>
    @if (minimumQuantitySurcharge?.showDisproportionateFeesHint) {
      <div class="font-size-smaller2 mt-2">
        {{ 'trade.confirm.hint.disproportionate-fees' | transloco }}
      </div>
    }
  </div>
</div>
